export default {"src":"/_next/static/media/logo_lumni_branca.0a2a4546.svg","height":25,"width":116,"blurWidth":0,"blurHeight":0};